export default (function isBrOnlyLine(line) {
  const trimmed = (line || "").trim();
  if (!trimmed) {
    return false;
  }
  const withoutFormatting = trimmed.replace(/<\/?(em|strong|u|b|i|span)\b[^>]*>/gi, "").trim();
  return /^<br\s*\/?>$/i.test(withoutFormatting);
});